<template>
  <div class="saleRateDetail">
    <!-- 头部导航栏 -->
    <el-menu
      class="el-menu-top"
      mode="horizontal"
      @select="handleSelect"
      background-color="#f3f3f3"
      text-color="#000"
      active-text-color="#409EFF"
    >
      <el-menu-item index="1" class="tabActive"
        >当前服务计费规则详情</el-menu-item
      >
    </el-menu>
    <!-- 基本信息 -->
    <div class="saleRateDetail_info">
      <div class="saleRateDetail_info_title">基本信息</div>
      <div class="saleRateDetail_info_content">
        <div class="saleRateDetail_info_name">
          服务计费名称:<span style="margin-left: 10px;">{{
            ruleForm.ormtb608ca01
          }}</span>
        </div>
        <div class="saleRateDetail_info_name">
          服务计费说明:<span style="margin-left: 10px;">{{
            ruleForm.ormtb608ca02
          }}</span>
        </div>
        <div class="saleRateDetail_info_name">
          下发范围:<span style="margin-left: 10px;">{{
            ruleForm.ormtb601Name
          }}</span>
        </div>
        <div class="saleRateDetail_info_name">
          下发时间:<span style="margin-left: 10px;">{{
            ruleForm.ormtb608ca15 || ruleForm.ormtb608ca18
          }}</span>
        </div>
      </div>
    </div>
    <!-- 标准计费/服务费 -->
    <div class="saleRateDetail_info" v-if="ruleForm.ormtb608ca04 == 0">
      <div class="saleRateDetail_info_title">充电费&服务费</div>
      <div class="saleRateDetail_info_content saleRateDetail_info_content_flex">
        <div class="saleRateDetail_info_name saleRateDetail_info_cost">
          标准电费:{{ ruleForm.ormtb608ca05 }}元/kwh
        </div>
        <div class="saleRateDetail_info_name saleRateDetail_info_cost">
          标准服务费:{{ ruleForm.ormtb608ca06 }}元/kwh
        </div>
      </div>
    </div>
    <!-- 充电费&服务费 -->
    <div class="saleRateDetail_cost" v-if="ruleForm.ormtb608ca04 == 1">
      <div class="saleRateDetail_info_title">充电费&服务费</div>
      <div class="saleRateDetail_cost_content">
        <div class="saleRateDetail_cost_title">分时电费</div>
        <div class="saleRateDetail_cost_content_box">
          <div class="saleRateDetail_cost_name">
            <span class="bg_color bg_color_red"></span>尖峰电费:<span
              class="cost_money"
              >{{ ruleForm.ormtb608ca07 }}</span
            >元/度
          </div>
          <div class="saleRateDetail_cost_name">
            <span class="bg_color bg_color_yellow"></span>峰时电费:<span
              class="cost_money"
              >{{ ruleForm.ormtb608ca08 }}</span
            >元/度
          </div>
          <div class="saleRateDetail_cost_name">
            <span class="bg_color bg_color_green"></span>平时电费:<span
              class="cost_money"
              >{{ ruleForm.ormtb608ca09 }}</span
            >元/度
          </div>
          <div class="saleRateDetail_cost_name">
            <span class="bg_color bg_color_blue"></span>谷时电费:<span
              class="cost_money"
              >{{ ruleForm.ormtb608ca10 }}</span
            >元/度
          </div>
        </div>
      </div>
      <div class="saleRateDetail_cost_content">
        <div class="saleRateDetail_cost_title">分时服务费</div>
        <div class="saleRateDetail_cost_content_box border_none">
          <div class="saleRateDetail_cost_name">
            <span class="bg_color bg_color_red"></span>尖峰服务费:<span
              class="cost_money"
              >{{ ruleForm.ormtb608ca11 }}</span
            >元/度
          </div>
          <div class="saleRateDetail_cost_name">
            <span class="bg_color bg_color_yellow"></span>峰时服务费:<span
              class="cost_money"
              >{{ ruleForm.ormtb608ca12 }}</span
            >元/度
          </div>
          <div class="saleRateDetail_cost_name">
            <span class="bg_color bg_color_green"></span>平时服务费:<span
              class="cost_money"
              >{{ ruleForm.ormtb608ca13 }}</span
            >元/度
          </div>
          <div class="saleRateDetail_cost_name">
            <span class="bg_color bg_color_blue"></span>谷时服务费:<span
              class="cost_money"
              >{{ ruleForm.ormtb608ca14 }}</span
            >元/度
          </div>
        </div>
      </div>
      <!-- 尖、峰、平、谷 -->
      <div class="saleRate_time">
        <div class="saleRate_time_tab">
          <div
            class="saleRate_time_tab_item"
            :style="{ backgroundColor: tabColors[index] }"
            v-for="(item, index) in timeTab"
            :key="index"
            :class="{ tab_active: timeTabIndex == index }"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="saleRate_time_content">
          <el-row>
            <el-col
              :span="4"
              class="saleRate_content_item"
              :style="{
                backgroundColor: getBackgroundColor(index),
                color: coloredItems[index] ? '#fff' : '',
              }"
              v-for="(item, index) in timeList"
              :key="index"
              >{{ item.time }}</el-col
            >
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: '',
      activeIndex: '1',
      timeList: [],
      coloredItems: {},
      timeTabIndex: null,
      timeTab: [
        {
          type: 1,
          name: '尖',
        },
        {
          type: 2,
          name: '峰',
        },
        {
          type: 3,
          name: '平',
        },
        {
          type: 4,
          name: '谷',
        },
      ],
      tabColors: ['#FF0000', '#F8AC59', '#23C6C8', '#1AB394'],
      show: false,
      ruleForm: {
        ormtb608ca01: '', //规则名称
        ormtb608ca02: '', //服务计费说明
        ormtb608ca04: 0, //计费规则模式 0标准计费 1分时计费
        ormtb608ca05: undefined, //标准电费（计费规则模式为0时有值）
        ormtb608ca06: undefined, //标准服务费（计费规则模式为0时有值）
        ormtb608ca07: undefined, //尖时电费（计费规则模式为1时有值）
        ormtb608ca08: undefined, //峰时电费（计费规则模式为1时有值）
        ormtb608ca09: undefined, //平时电费（计费规则模式为1时有值）
        ormtb608ca10: undefined, //谷时电费（计费规则模式为1时有值）
        ormtb608ca11: undefined, //尖时服务费（计费规则模式为1时有值）
        ormtb608ca12: undefined, //峰时服务费（计费规则模式为1时有值）
        ormtb608ca13: undefined, //平时服务费（计费规则模式为1时有值）
        ormtb608ca14: undefined, //谷时服务费（计费规则模式为1时有值）
        ormtb608ca15: '', //下发时间
        ormtb601id: '', //下发范围
        list: [], //下发范围数组格式,
        ormtb608ca18:'',
      },
      selectTimeList: [],
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.timeList = this.generateTimeSlotsBetter()
    this.getDetail()
  },
  methods: {
    // 获取详情信息
    getDetail() {
      var url = 'orm/ormtb608/detail'
      this.axios
        .post(url, { ormtb608id: this.id })
        .then(res => {
          if (res.data.code == 200) {
            this.ruleForm = res.data.data
            let objData = res.data.data
            objData.ormtb608ca04 = Number(objData.ormtb608ca04)
            objData.list = objData.ormtb601IdList
            objData.ormtb601id = objData.ormtb601IdList.join(',')
            this.ruleForm = res.data.data
            this.timeList = res.data.data.ormtb604List
            this.selectTimeList = res.data.data.ormtb604List
            this.timeList.forEach((item, index) => {
              item.time = `${item.ormtb604ca01}-${item.ormtb604ca02}`
              let type = null
              if (item.ormtb604ca05 == '尖') {
                type = 0
              } else if (item.ormtb604ca05 == '峰') {
                type = 1
              } else if (item.ormtb604ca05 == '平') {
                type = 2
              } else if (item.ormtb604ca05 == '谷') {
                type = 3
              }
              this.$set(this.coloredItems, index, this.tabColors[type])
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {})
    },
    handleSelect(key, keyPath) {
      this.activeIndex = String(key)
    },
    getBackgroundColor(index) {
      return this.coloredItems[index] || 'transparent'
    },
    generateTimeSlotsBetter() {
      const slots = []
      for (let i = 0; i < 48; i++) {
        const startHour = Math.floor(i / 2)
        const startMinute = i % 2 === 0 ? '00' : '30'

        let endHour, endMinute
        if (i === 47) {
          // 最后一个时间段
          endHour = '24'
          endMinute = '00'
        } else {
          const nextHalf = i + 1
          endHour = Math.floor(nextHalf / 2)
            .toString()
            .padStart(2, '0')
          endMinute = nextHalf % 2 === 0 ? '00' : '30'
        }

        const start = `${startHour.toString().padStart(2, '0')}:${startMinute}`
        const end = `${endHour}:${endMinute}`
        slots.push(`${start}-${end}`)
      }
      return slots
    },
  },
}
</script>
<style scoped>
.saleRateDetail {
  min-height: 100%;
  background-color: #f3f3f3 !important;
  padding-bottom: 20px;
}

.el-menu-top {
  border-bottom: 1px solid #cdcdcd !important;
}

/deep/.is-active {
  border: none !important;
}

.tabActive {
  position: relative;
  /* background-color: red!important; */
  color: #199fff !important;
}

.tabActive::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #199fff;
}

/* 基本信息 */
.saleRateDetail_info {
  padding: 0 32px;
  box-sizing: border-box;
  margin-top: 20px;
  background-color: #fff;
}

.saleRateDetail_info_title {
  height: 48px;
  line-height: 48px;
  color: #000000;
  font-size: 18px;
  border-bottom: 1px solid #cdcdcd;
}

.saleRateDetail_info_content {
  padding: 20px 0 38px 0;
  box-sizing: border-box;
}

.saleRateDetail_info_name {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

/* 电费&服务费 */
.saleRateDetail_cost {
  background-color: #fff;
  padding: 0 32px;
  box-sizing: border-box;
  margin-top: 20px;
}

.bg_color {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 10px;
}

.bg_color_red {
  background: #ed5565;
}

.bg_color_yellow {
  background: #f8ac59;
}

.bg_color_green {
  background: #23c6c8;
}

.bg_color_blue {
  background: #1a8f77;
}

.saleRateDetail_cost_title {
  font-size: 16px;
  color: #333333;
  height: 69px;
  line-height: 69px;
}

.saleRateDetail_cost_content_box {
  width: 890px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 1px solid #d9d9d9;
}

.saleRateDetail_cost_name {
  margin-right: 291px;
  margin-bottom: 32px;
  font-size: 14px;
  color: #333333;
}

.cost_money {
  color: #ff0000;
  margin-left: 10px;
}

.border_none {
  border: none !important;
}

/* 尖 */
.saleRate_time {
  padding-bottom: 62px;
  box-sizing: border-box;
}

.saleRate_time_tab {
  display: flex;
  align-items: center;
  height: 72px;
}

.saleRate_time_tab_item {
  width: 42px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: #f8ac59;
  margin-right: 14px;
  font-size: 14px;
  color: #fff;
}

.tab_active {
  width: 42px;
  height: 32px;
  line-height: 32px;
  font-size: 18px;
}

.saleRate_time_content {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #d8d8d8;
  border-left: 1px solid #d8d8d8;
}

.saleRate_content_item {
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-right: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  font-size: 18px;
}

/* 标准计费 */
.saleRateDetail_info_content_flex {
  display: flex;
  justify-content: space-between;
}

.saleRateDetail_info_cost {
  width: 50%;
}
</style>
